const PUBNINJA_FAVICON = "https://pubninja.com/assets/images/Favicon.png";
const PUBNINJA_LOGO = "https://cheesecake.articleassets.meaww.com/pubninja/logo-black.svg";
const HOME_LINK = "https://pubninja.com/";
const DEFAULT_COVER_PICURE_URL = "https://cheesecake.author-documents.meaww.com/default/author_cover2_450_250";
//const DEFULT_PROFILE_PICTURE_URL = "https://cheesecake.author-documents.meaww.com/default/author2_150_150";
const DEFULT_PROFILE_PICTURE_URL = "https://cheesecake.articleassets.meaww.com/assets/new_user_profile_150x150.png"
const DEFAULT_COVER_PICTURE = "https://cdn.meaww.com/assets/img/Cover.png";
export { PUBNINJA_LOGO, PUBNINJA_FAVICON, HOME_LINK, DEFAULT_COVER_PICURE_URL, DEFULT_PROFILE_PICTURE_URL, DEFAULT_COVER_PICTURE };
